import {
  addUniqueValueToArray
} from 'utils/redux'

export const NAMESPACE = 'KanBo/blockers/'
export const SET_LOAD_STATUS = NAMESPACE + 'SET_LOAD_STATUS'
export const ADD = NAMESPACE + 'ADD'
export const SET = NAMESPACE + 'SET'
export const ADD_ARRAY = NAMESPACE + 'ADD_ARRAY'
export const REMOVE = NAMESPACE + 'REMOVE'
export const SET_POSITION = NAMESPACE + 'SET_POSITION'
export const SET_NAME = NAMESPACE + 'SET_NAME'
export const SET_DESCRIPTION = NAMESPACE + 'SET_DESCRIPTION'

const initialState = {
  ids: [],
  byId: {},
  isLoading: false,
  isLoaded: false,
}

export default function reducer (state = initialState, action = {}) {
  switch (action.type) {
    case SET_LOAD_STATUS:
      return {
        ...state,
        isLoading: action.payload.isLoading,
        isLoaded: action.payload.isLoaded
      }
    case ADD:
      return {
        ...state,
        ids: addUniqueValueToArray({
          array: state.ids,
          value: action.payload.id,
          index: action.payload.index
        }),
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            ...action.payload,
          }
        }
      }
    case SET:
      return state.byId[action.payload.id] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.id]: {
            ...state.byId[action.payload.id],
            ...action.payload,
          }
        }
      } : state
    case ADD_ARRAY: {
      const newState = {
        ...state,
        ids: [ ...state.ids ],
        byId: { ...state.byId }
      }
      action.payload.forEach(item => {
        newState.ids = addUniqueValueToArray({
          array: newState.ids,
          value: item.id,
          index: item.index
        })
        newState.byId[item.id] = {
          ...newState.byId[item.id],
          ...item,
        }
      })
      return newState
    }
    case REMOVE: {
      const newState = {
        ...state,
        ids: [ ...state.ids.filter(id => id !== action.payload.id) ],
        byId: { ...state.byId }
      }
      delete newState.byId[action.payload.id]
      return newState
    }
    case SET_POSITION:
      return state.byId[action.payload.blockerId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.blockerId]: {
            ...state.byId[action.payload.blockerId],
            position: action.payload.position,
          }
        }
      } : state
    case SET_NAME:
      return state.byId[action.payload.blockerId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.blockerId]: {
            ...state.byId[action.payload.blockerId],
            name: action.payload.name,
          }
        }
      } : state
    case SET_DESCRIPTION:
      return state.byId[action.payload.blockerId] ? {
        ...state,
        byId: {
          ...state.byId,
          [action.payload.blockerId]: {
            ...state.byId[action.payload.blockerId],
            description: action.payload.description,
          }
        }
      } : state
    default: return state
  }
}

export function setLoadStatus ({ isLoading, isLoaded }) {
  return {
    type: SET_LOAD_STATUS,
    payload: {
      isLoading,
      isLoaded
    }
  }
}

export function add (data) {
  return {
    type: ADD,
    payload: data
  }
}

export function set (data) {
  return {
    type: SET,
    payload: data
  }
}

export function addArray (array) {
  return {
    type: ADD_ARRAY,
    payload: array
  }
}

export function remove ({ id }) {
  return {
    type: REMOVE,
    payload: {
      id
    }
  }
}

export function setPosition ({ blockerId, position }) {
  return {
    type: SET_POSITION,
    payload: {
      blockerId,
      position,
    }
  }
}

export function setName ({ blockerId, name }) {
  return {
    type: SET_NAME,
    payload: {
      blockerId,
      name,
    }
  }
}

export function setDescription ({ blockerId, description }) {
  return {
    type: SET_DESCRIPTION,
    payload: {
      blockerId,
      description,
    }
  }
}
